import React from 'react';

const BodyProgress = props => <div className="body-progress" { ...props }></div>;

export default BodyProgress;
